import styled from 'styled-components';

export const RefinedAccessHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
